import { useRouterState } from '@tanstack/react-router';

import Badge from '@src/shared/ui/Badge';
import IconButton from '@src/shared/ui/Button/IconButton';
import Link from '@src/shared/ui/Link';
import { Box } from '@src/shared/ui/layout';
import { MailIcon, NotificationsIcon, SearchIcon, TasksIcon } from '@src/shared/ui/icons';

const StyleSheet = {
  root: {
    alignSelf: 'start',
    color: 'common.black',
    display: 'flex',
    gap: '5px',
    '& .MuiIconButton-root:hover, & .MuiIconButton-root.Mui-active': {
      backgroundColor: 'grey.600',
      color: 'common.black',
    },
  }
};

export default function TopMenu() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const isTasksActive = pathname.startsWith('/tasks');

  return (
    <Box sx={StyleSheet.root}>
      <IconButton color="inherit" onClick={() => console.log('search')}>
        <SearchIcon color="inherit" />
      </IconButton>
      <IconButton color="inherit" onClick={() => console.log('notifications')}>
        <Badge badgeContent={1} color="primary" invisible={false}>
          <NotificationsIcon color="inherit" />
        </Badge>
      </IconButton>
      <IconButton color="inherit" onClick={() => console.log('mail')}>
        <Badge badgeContent={13} color="primary" invisible={true}>
          <MailIcon color="inherit" />
        </Badge>
      </IconButton>
      <IconButton
        color="inherit"
        component={Link} to="/tasks"
        className={isTasksActive ? 'Mui-active' : undefined}
      >
        <Badge badgeContent={55} color="primary" invisible={false}>
          <TasksIcon color="inherit" />
        </Badge>
      </IconButton>
    </Box>
  );
}
